import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { withClientState } from 'apollo-link-state';
import { onError } from 'apollo-link-error';
import { createUploadLink } from 'apollo-upload-client';

const cache = new InMemoryCache();

const httpLink = new createUploadLink({
  uri: window._env_.REACT_APP_GRAPHQL_URL,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');
  const initialToken = localStorage.getItem('initialToken');
  let imp = {};
  if (initialToken) {
    imp = {
      imp: initialToken,
    };
  }
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      ...imp,
    },
  };
});

const stateLink = withClientState({
  cache,
});

const link = ApolloLink.from([
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        if (message === 'Not Authorised!') {
          localStorage.removeItem('token');
          window.location.replace('/logout');
        }
        try {
          console.log(`[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`);
        } catch (error) {
          console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
        }
      });
    }

    if (networkError) console.log(`[Network error]: ${networkError}`);
  }),
  stateLink,
  authLink,
  httpLink,
]);

const client = new ApolloClient({
  link,
  cache,
});

export default client;
